import { useMemo } from 'react'
import { RequestAssigneeGroups } from '@trustero/trustero-api-web/lib/request/request_pb'
import { Empty } from 'google-protobuf/google/protobuf/empty_pb'
import { RequestPromiseClient } from '@trustero/trustero-api-web/lib/request/request_grpc_web_pb'
import { useRpcReadAccess } from 'src/app/AppAuth/useReadAccess'
import { GatekeeperFlag, IsGatekeeperEnabled } from 'src/context/Gatekeeper'
import { useSwrImmutableGrpc } from '../useSwrImmutableGrpc'
import { NewGrpcResponse, GrpcResponse } from '../hooks/types'

export const useRequestAssigneeGroups =
  (): GrpcResponse<RequestAssigneeGroups> => {
    const canRead = useRpcReadAccess('/request.Request/ListAssigneeGroups')
    const { response } = useSwrImmutableGrpc(
      RequestPromiseClient.prototype.listAssigneeGroups,
      new Empty(),
      canRead && IsGatekeeperEnabled(GatekeeperFlag.NEW_USER_ROLES_UI),
    )
    return NewGrpcResponse(response)
  }

// Group id -> name, for showing a request's group assignee.
export const useRequestAssigneeGroupNames = (): Record<string, string> => {
  const { data } = useRequestAssigneeGroups()
  return useMemo(
    () =>
      Object.fromEntries(
        data?.getItemsList().map((g) => [g.getId(), g.getName()]) ?? [],
      ),
    [data],
  )
}
